import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12c0 5.5228 4.47715 10 10 10 5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10zm5.6369 9.1263c.9185 0 1.6631-.7446 1.6631-1.66317 0-.91853-.7446-1.66314-1.6631-1.66314s-1.6631.74461-1.6631 1.66314c0 .91857.7446 1.66317 1.6631 1.66317zm-6.7351 3.1081c-.0996-.0647-.386-.4459-1.1698-2.323L8.05562 7.8913H5.30005l4.02836 9.7253c.00862.0209.02323.0387.04196.0512.01873.0125.04076.0192.0633.0193.02254 0 .04459-.0066.06336-.0191.01877-.0125.03343-.0303.04212-.0511l1.38455-3.3145c.0045-.0121.0048-.0255.0009-.0378-.004-.0123-.012-.023-.0228-.0302zm5.1624 0c-.0995-.0647-.3859-.4459-1.1697-2.323l-1.6764-4.0201h-2.7556l4.0284 9.7253c.0086.0209.0232.0387.0419.0512.0188.0125.0408.0192.0633.0193.0226 0 .0446-.0066.0634-.0191.0188-.0125.0334-.0303.0421-.0511l1.3845-3.3145c.0046-.0121.0049-.0255.0009-.0378-.0039-.0123-.012-.023-.0228-.0302z",
    fill: "currentColor"
  }));
});